import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberWorkingExperience } from "./routeType";

const { key, getPath } = getApi("members.workingExperience.get");

type IExtractedRouteType =
  IMemberWorkingExperience["workingExperienceSingleRetrieve"];

export type IGetMemberWorkingExperience = IPickSingleQuery<IExtractedRouteType>;

const getMemberWorkingExperience: Fetcher<
  IGetMemberWorkingExperience["response"],
  IGetMemberWorkingExperience["variables"]
> = ({ experienceId, ...params }) => {
  return axiosClient.get(getPath({ experienceId }), { params });
};

export const useGetMemberWorkingExperience = createQuery({
  queryKey: [key],
  fetcher: getMemberWorkingExperience,
});
